// slider
$(function() {
	if($('.bSlide_main').length) {
		$('.bSlide_main').slick({
			autoplay: true,
			autoplaySpeed: 3700,
			fade: true,
			speed: 1500,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
		});
	}
});
// ranking item（displayをstyleで明示的に切り替える版）
$(function () {
  $('.sec.bItem.ranking').each(function () {
    var $sec  = $(this);
    var $tabs = $sec.find('.ranking_nav_col');
    var $lists = $sec.find('.ranking_list');

    if (!$tabs.length || !$lists.length) return;

    function showById(id) {
      if (!id) return;

      // タブ
      $tabs.removeClass('active');
      $tabs.filter('[data-id="' + id + '"]').addClass('active');

      // リスト（元HTMLどおり style="display: block/none" を作る）
      $lists.each(function(){
        var $el = $(this);
        var isTarget = ('#' + $el.attr('id')) === id;
        $el.stop(true, true); // アニメ停止
        $el.css('display', isTarget ? 'block' : 'none');
      });
    }

    // 初期：1個目のタブ
    showById($tabs.eq(0).data('id'));

    // クリック
    $tabs.on('click', function () {
      var id = $(this).data('id');
      if (!id) return;
      showById(id);
    });
  });
});



// header menu
$(function() {
	if($('.header_menu').length) {
		$('.header_menu').removeClass('active');
		$('.bHeader_btn').on('click', function() {
			$(this).toggleClass('active');
			// $('.header_menu').toggleClass('active');
			$('.header_menu').fadeToggle('600');
		});
	}
});

// footer toggle
if (window.matchMedia( "(max-width: 750px)" ).matches) {
	$(window).on('load', function() {
		$('.footer_col_list').hide();
		$('.footer_col_ttl').removeClass('active');
		$('.footer_col_ttl').on('click', function() {
			$(this).toggleClass('active');
			$(this).next().slideToggle();
		});
	});
}
